import styled from '@emotion/styled';
import { Button } from 'components';
import { formatDateWithTime } from 'core';

const S = {
  Card: styled.div`
    padding: 28px;
    background: #ffffff;
    box-shadow: 0px 1px 4px rgba(84, 86, 90, 0.24);
    border-radius: 8px;
  `,
  HeaderRow: styled.div`
    display: flex;
    align-items: center;
  `,
  Name: styled.div`
    font-size: 18px;
    font-weight: 700;
    flex: 1;
    color: #000000;
  `,
  Date: styled.div`
    font-size: 14px;
    color: #4d4d4d;
  `,
  Description: styled.div`
    font-size: 18px;
    color: #000000;
    margin-top: 6px;
  `,
  DownloadButtonWrapper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
  `,
  DownloadButton: styled(Button)`
    color: #2fb62c;
  `,
  StyledChip: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    background-color: #fef1ea;
    border-radius: 4px;
    margin-right: 4px;
    font-family: 'Arial';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #f06c2d;
  `,
  CandidateName: styled.div`
    font-family: 'Arial';
    font-size: 16px;
    color: #4d4d4d;
  `,
};

type DocumentCardProps = {
  id: number;
  name: string;
  notificationSentOn: string | undefined;
  isDownloaded: boolean;
  description: string;
  isDownloadingEnabled: boolean;
  candidateFullName: string;
  onDownload: () => void;
};

export const DocumentCard = ({
  name,
  notificationSentOn,
  id,
  isDownloaded,
  description,
  onDownload,
  isDownloadingEnabled,
  candidateFullName,
}: DocumentCardProps) => {
  return (
    <S.Card>
      <S.HeaderRow>
        {!isDownloaded && <S.StyledChip>New</S.StyledChip>}
        <S.Name>{name}</S.Name>
        {notificationSentOn && <S.Date>Notification sent on: {formatDateWithTime(notificationSentOn)}</S.Date>}
      </S.HeaderRow>

      <S.Description>{description}</S.Description>

      <S.DownloadButtonWrapper>
        <S.CandidateName>Candidate: {candidateFullName}</S.CandidateName>

        <S.DownloadButton
          variant="discrete"
          text="Download"
          icon="FiDownload"
          textPosition="right"
          disabled={isDownloadingEnabled}
          onClick={onDownload}
        />
      </S.DownloadButtonWrapper>
    </S.Card>
  );
};
